// extracted by mini-css-extract-plugin
export var arrow = "tooltip-arrow-module--arrow--93776";
export var border = "tooltip-arrow-module--border--cce07";
export var down = "tooltip-arrow-module--down--a5956";
export var end = "tooltip-arrow-module--end--113f2";
export var fill = "tooltip-arrow-module--fill--6ae88";
export var left = "tooltip-arrow-module--left--30182";
export var right = "tooltip-arrow-module--right--53044";
export var start = "tooltip-arrow-module--start--bfc33";
export var up = "tooltip-arrow-module--up--0de62";